// ASD Questions

import type { Question } from '@/types/assessment';

export const aqQuestions: Question[] = [
  // Social Skills
  {
    id: 1,
    text: "I prefer to do things with others rather than on my own.",
    category: 'social',
    reverse: true
  },
  {
    id: 2,
    text: "I prefer to do things the same way over and over again.",
    category: 'routine',
    reverse: false
  },
  {
    id: 3,
    text: "If I try to imagine something, I find it very easy to create a picture in my mind.",
    category: 'imagination',
    reverse: true
  },
  {
    id: 4,
    text: "I frequently get so strongly absorbed in one thing that I lose sight of other things.",
    category: 'attention',
    reverse: false
  },
  {
    id: 5,
    text: "I often notice small sounds when others do not.",
    category: 'attention',
    reverse: false
  },
  {
    id: 6,
    text: "I usually notice car number plates or similar strings of information.",
    category: 'attention',
    reverse: false
  },
  {
    id: 7,
    text: "Other people frequently tell me that what I've said is impolite, even though I think it is polite.",
    category: 'social',
    reverse: false
  },
  {
    id: 8,
    text: "When I'm reading a story, I can easily imagine what the characters might look like.",
    category: 'imagination',
    reverse: true
  },
  {
    id: 9,
    text: "I am fascinated by dates.",
    category: 'attention',
    reverse: false
  },
  {
    id: 10,
    text: "In a social group, I can easily keep track of several different people's conversations.",
    category: 'social',
    reverse: true
  },
  {
    id: 11,
    text: "I find social situations easy.",
    category: 'social',
    reverse: true
  },
  {
    id: 12,
    text: "I tend to notice details that others do not.",
    category: 'attention',
    reverse: false
  },
  {
    id: 13,
    text: "I would rather go to a library than to a party.",
    category: 'social',
    reverse: false
  },
  {
    id: 14,
    text: "I find making up stories easy.",
    category: 'imagination',
    reverse: true
  },
  {
    id: 15,
    text: "I find myself drawn more strongly to people than to things.",
    category: 'social',
    reverse: true
  },
  {
    id: 16,
    text: "I tend to have very strong interests which I get upset about if I can't pursue.",
    category: 'routine',
    reverse: false
  },
  {
    id: 17,
    text: "I enjoy social chit-chat.",
    category: 'social',
    reverse: true
  },
  {
    id: 18,
    text: "When I talk, it isn't always easy for others to get a word in edgeways.",
    category: 'communication',
    reverse: false
  },
  {
    id: 19,
    text: "I am fascinated by numbers.",
    category: 'attention',
    reverse: false
  },
  {
    id: 20,
    text: "When I'm reading a story, I find it difficult to work out the characters' intentions.",
    category: 'social',
    reverse: false
  },
  {
    id: 21,
    text: "I don't particularly enjoy reading fiction.",
    category: 'imagination',
    reverse: false
  },
  {
    id: 22,
    text: "I find it hard to make new friends.",
    category: 'social',
    reverse: false
  },
  {
    id: 23,
    text: "I notice patterns in things all the time.",
    category: 'attention',
    reverse: false
  },
  {
    id: 24,
    text: "I would rather go to the theatre than to a museum.",
    category: 'social',
    reverse: true
  },
  {
    id: 25,
    text: "It does not upset me if my daily routine is disturbed.",
    category: 'routine',
    reverse: true
  },
  {
    id: 26,
    text: "I frequently find that I don't know how to keep a conversation going.",
    category: 'communication',
    reverse: false
  },
  {
    id: 27,
    text: "I find it easy to 'read between the lines' when someone is talking to me.",
    category: 'communication',
    reverse: true
  },
  {
    id: 28,
    text: "I usually concentrate more on the whole picture, rather than the small details.",
    category: 'attention',
    reverse: true
  },
  {
    id: 29,
    text: "I am not very good at remembering phone numbers.",
    category: 'attention',
    reverse: true
  },
  {
    id: 30,
    text: "I don't usually notice small changes in a situation, or a person's appearance.",
    category: 'attention',
    reverse: true
  },
  {
    id: 31,
    text: "I know how to tell if someone listening to me is getting bored.",
    category: 'social',
    reverse: true
  },
  {
    id: 32,
    text: "I find it easy to do more than one thing at once.",
    category: 'attention',
    reverse: true
  },
  {
    id: 33,
    text: "When I talk on the phone, I'm not sure when it's my turn to speak.",
    category: 'communication',
    reverse: false
  },
  {
    id: 34,
    text: "I enjoy doing things spontaneously.",
    category: 'routine',
    reverse: true
  },
  {
    id: 35,
    text: "I am often the last to understand the point of a joke.",
    category: 'communication',
    reverse: false
  },
  {
    id: 36,
    text: "I find it easy to work out what someone is thinking or feeling just by looking at their face.",
    category: 'social',
    reverse: true
  },
  {
    id: 37,
    text: "If there is an interruption, I can switch back to what I was doing very quickly.",
    category: 'attention',
    reverse: true
  },
  {
    id: 38,
    text: "I am good at social chit-chat.",
    category: 'social',
    reverse: true
  },
  {
    id: 39,
    text: "People often tell me that I keep going on and on about the same thing.",
    category: 'communication',
    reverse: false
  },
  {
    id: 40,
    text: "When I was young, I used to enjoy playing games involving pretending with other children.",
    category: 'imagination',
    reverse: true
  },
  {
    id: 41,
    text: "I like to collect information about categories of things (e.g. types of car, types of bird, types of train, types of plant, etc.).",
    category: 'attention',
    reverse: false
  },
  {
    id: 42,
    text: "I find it difficult to imagine what it would be like to be someone else.",
    category: 'imagination',
    reverse: false
  },
  {
    id: 43,
    text: "I like to plan any activities I participate in carefully.",
    category: 'routine',
    reverse: false
  },
  {
    id: 44,
    text: "I enjoy social occasions.",
    category: 'social',
    reverse: true
  },
  {
    id: 45,
    text: "I find it difficult to work out people's intentions.",
    category: 'social',
    reverse: false
  },
  {
    id: 46,
    text: "New situations make me anxious.",
    category: 'routine',
    reverse: false
  },
  {
    id: 47,
    text: "I enjoy meeting new people.",
    category: 'social',
    reverse: true
  },
  {
    id: 48,
    text: "I am a good diplomat.",
    category: 'social',
    reverse: true
  },
  {
    id: 49,
    text: "I am not very good at remembering people's date of birth.",
    category: 'attention',
    reverse: true
  },
  {
    id: 50,
    text: "I find it very easy to play games with children that involve pretending.",
    category: 'imagination',
    reverse: true
  }
];

export const aqResponseOptions = [
  { value: 1, label: 'Definitely Agree', color: 'bg-blue-600' },
  { value: 2, label: 'Slightly Agree', color: 'bg-blue-400' },
  { value: 3, label: 'Slightly Disagree', color: 'bg-orange-400' },
  { value: 4, label: 'Definitely Disagree', color: 'bg-orange-600' }
];

export const categoryInfo = {
  social: { name: 'Social Skills', color: 'bg-blue-100 text-blue-800', icon: '👥' },
  communication: { name: 'Communication', color: 'bg-green-100 text-green-800', icon: '💬' },
  imagination: { name: 'Imagination', color: 'bg-purple-100 text-purple-800', icon: '🎭' },
  attention: { name: 'Attention to Detail', color: 'bg-yellow-100 text-yellow-800', icon: '🔍' },
  routine: { name: 'Routine & Change', color: 'bg-red-100 text-red-800', icon: '🔄' }
};